var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v(_vm._s(_vm.item.phone_number || _vm.item.email_address ? ((_vm.item.phone_number ? (_vm.item.phone_number_prepend + _vm.item.phone_number + ' ') : '') + (_vm.item.email_address || '')) : ('-')))])}
var staticRenderFns = []

export { render, staticRenderFns }